import React, { Component } from 'react';
import { Dimensions } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import {
  map as _map,
  sum as _sum,
  values as _values,
  get as _get,
  has as _has,
  forEach as _forEach,
  isObject as _isObject,
  isFunction as _isFunction,
} from 'lodash';
import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { SubTrayItemView } from '../../CommonUI';
import FrameworkTestKeys from '../../FrameworkTestKeys';

import { AnimationManager } from './AnimationManager';
import { SubTrayGroup, CustomSubTrayItemView, Loading, SubTrayError } from './Components';
import Tray from './Tray';
import styles from './Tray.Styles';
import { TRAY_TYPES, Tray_Actions_Types } from './Utils';
import { defaultNormalTrayHeight } from './withTray/withTrayHelper';

class TrayHoc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSubTray: -1,
      trayAction: '',
      expandedTrayItems: [],
      totalItems: 0,
      expandedTrayItem: {},
    };

    this.animationManager = new AnimationManager();
  }

  componentDidUpdate(_, prevState) {
    const { activeSubTray } = this.state;
    const { data } = this.props;

    const trayItems = this.renderTrayItems(data);

    const expandedTrayItems =
      activeSubTray !== -1 ? _get(trayItems[activeSubTray], 'expandedTrayItems', []) : [];

    if (
      (expandedTrayItems.length && !this.state.expandedTrayItems.length) ||
      (prevState.activeSubTray !== activeSubTray && activeSubTray !== -1)
    ) {
      this.getExpandedTrayItems(expandedTrayItems);
    }
  }

  onSelectedTab = item => {
    this.setState({ expandedTrayItem: item });
    if (_isObject(item)) {
      this.setState({
        expandedTrayItems: item.products,
      });
    } else {
      const { activeSubTray } = this.state;

      const { data } = this.props;

      const trayItems = this.renderTrayItems(data);
      const expandedTrayItems =
        activeSubTray !== -1 ? _get(trayItems[activeSubTray], 'expandedTrayItems', []) : [];

      this.getExpandedTrayItems(expandedTrayItems);
    }
  };

  getIconName = trayItem => {
    if (trayItem.icon) {
      return trayItem.icon;
    } else if (trayItem.title === 'tray_accounts_section_title') {
      return 'ic_account_settings_admin';
    } else {
      return 'ic_connected_devices';
    }
  };

  getExpandedTrayItems = categories => {
    let items = [];
    _forEach(categories, item => {
      items = [...items, ...item.products];
    });
    this.setState({
      expandedTrayItems: items,
      totalItems: items.length,
    });
  };

  toggleModal = index => {
    const { activeSubTray } = this.state;
    const { toggleModal } = this.props;
    clearTimeout(this.swichTimeOut);
    if (index === undefined) {
      this.setState({ activeSubTray: -1, trayAction: Tray_Actions_Types.CLOSE }, () =>
        toggleModal(false),
      );
    } else {
      this.setState({ expandedTrayItem: {} });
      switch (activeSubTray) {
        case -1:
          this.setState({ activeSubTray: index, trayAction: Tray_Actions_Types.OPEN }, () =>
            toggleModal(true),
          );
          break;
        case index:
          this.setState({ activeSubTray: -1, trayAction: Tray_Actions_Types.CLOSE }, () =>
            toggleModal(false),
          );
          break;
        default: {
          this.setState({ trayAction: Tray_Actions_Types.CHANGE });
          const changeSpeed = 100;
          this.swichTimeOut = setTimeout(() => {
            this.setState({
              trayAction: Tray_Actions_Types.SWITCH,
              activeSubTray: index,
            });
          }, changeSpeed);
        }
      }
    }
  };

  handleOnPressSubTrayItems = (subTrayItem, isLocked) => {
    const { onPressSubTrayItems } = this.props;
    onPressSubTrayItems(subTrayItem, isLocked);
    this.toggleModal();
  };

  handleOnPressTrayItem = (index, item) => {
    const { onPressTrayItem } = this.props;
    onPressTrayItem(
      item,
      () => this.toggleModal(index),
      () => this.toggleModal(),
    );
  };

  handleOnPressTobi = () => {
    const { onPressTobi, showModal } = this.props;
    if (_isFunction(onPressTobi)) {
      onPressTobi(showModal);
    } else {
      showModal();
    }
  };

  shouldBeExpandedTray = (expandedTrayItems = [], isExpandedTrayEnabled = false) => {
    return isExpandedTrayEnabled && this.state.totalItems >= 6 && expandedTrayItems.length >= 2;
  };

  _setNormalTrayHeightBasedOnActiveSubTray = activeSubTrayItems => {
    const { setNormalTrayHeightBasedOnActiveSubTray } = this.props;
    if (_isFunction(setNormalTrayHeightBasedOnActiveSubTray)) {
      return setNormalTrayHeightBasedOnActiveSubTray(activeSubTrayItems);
    }
  };

  renderCards = (items, notification, trayPlaceHolders, accessibilityID, isExpandedTrayEnabled) => {
    const {
      images,
      componentList,
      subTrayImageProps,
      subTraySubTitleProps,
      isSubTrayItemsLocked,
      cardDescriptionSpace,
    } = this.props;

    return items.map((item, index) => {
      const isLocked = isSubTrayItemsLocked && item.isLockable;
      if (_has(item, 'componentId')) {
        const SubTrayComponent = _get(componentList, item.componentId, () => null);

        return (
          <CustomSubTrayItemView
            accessibilityLabel={accessibilityID}
            onPress={() => this.handleOnPressSubTrayItems(item, isLocked)}
            key={`SubTray-Card-${index}-${item.itemTitle}`}
          >
            <SubTrayComponent
              key={index}
              image={images[item.itemImage]}
              onPress={() => this.handleOnPressSubTrayItems(item, isLocked)}
              withLock={isLocked}
              {...item}
              index={index}
              notification={_get(notification, item.itemTitle, 0)}
              trayPlaceHolders={trayPlaceHolders}
            />
          </CustomSubTrayItemView>
        );
      }

      return (
        <SubTrayItemView
          withLock={isLocked}
          key={`SubTray-Card-${index}-${item.itemTitle}`}
          notification={_get(notification, item.itemTitle, 0)}
          {...item}
          cardDescriptionSpace={cardDescriptionSpace}
          image={images[isLocked ? item.lockedItemImage ?? item.itemImage : item.itemImage]}
          onPress={() => this.handleOnPressSubTrayItems(item, isLocked)}
          index={index}
          itemSubTitle={isLocked ? item.lockedItemSubTitle ?? item.itemSubTitle : item.itemSubTitle}
          trayPlaceHolders={trayPlaceHolders}
          accessibilityID={accessibilityID}
          imageProps={subTrayImageProps}
          subTitleProps={subTraySubTitleProps}
          containerViewStyle={[
            styles.subTrayItemViewContainer(isExpandedTrayEnabled, index),
            item.containerViewStyle,
          ]}
        />
      );
    });
  };

  renderContent = (subTray, title, subTrayItem) => {
    const accessibilityID = `${FrameworkTestKeys.TrayHocST}${subTrayItem.subTrayID}${FrameworkTestKeys.TrayHocItem}`;
    const {
      isLoadingError,
      errorConfig = { data: {}, onTryAgainPress: {} },
      isModalVisible,
      notificationsCount,
      trayPlaceHolders = {},
      subTrayCardsLoadingConfig,
      shimmerPlaceholderConfig,
      renderSubTrayFooter,
      renderSubTrayHeader,
      renderSubTrayHeaderBeforeDescription,
      trayHeight,
      subTrayCardsContainerStyle,
      images,
      isSubTrayItemsLocked,
      subTrayGroupStyles = {},
    } = this.props;

    const trayShouldBeExpandable = this.shouldBeExpandedTray(
      subTray.expandedTrayItems,
      subTray.isExpandedTrayEnabled,
    );

    const subTrayAnimations = this.animationManager.getSubTrayAnimations(
      isModalVisible,
      this.state.trayAction,
    );

    if (isLoadingError) {
      return (
        <SubTrayError
          errorConfig={errorConfig}
          description={subTray.subTrayDesc}
          trayPlaceHolders={trayPlaceHolders}
          descriptionAnimation={subTrayAnimations?.descriptionAnimation}
          accessibilityID={accessibilityID}
          subTrayItem={subTrayItem}
          isExpandedTray={trayShouldBeExpandable}
          images={images}
        />
      );
    }

    return (
      <SubTrayGroup
        withLock={isSubTrayItemsLocked && subTray.subTrayTitle !== 'sub_tray_my_products_title'}
        items={
          subTray.isLoading
            ? [
              <Loading
                key="loading"
                subTrayCardsLoadingConfig={subTrayCardsLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />,
            ]
            : this.renderCards(
              trayShouldBeExpandable && subTray.subTrayTitle === 'sub_tray_my_products_title'
                ? this.state.expandedTrayItems
                : subTray.subTrayItems,
              notificationsCount[title],
              trayPlaceHolders,
              accessibilityID,
              trayShouldBeExpandable,
            )
        }
        getCategoryName={subTray.getCategoryName}
        totalItemsCount={this.state.totalItems}
        onSelectedTab={this.onSelectedTab}
        expandedTrayItem={this.state.expandedTrayItem}
        trayShouldBeExpandable={trayShouldBeExpandable}
        expandedTrayItems={subTray.expandedTrayItems}
        setTrayHeight={this.props.setTrayHeight}
        notificationCount={notificationsCount}
        description={subTray.subTrayDesc}
        isVisible={isModalVisible}
        trayAction={this.state.trayAction}
        key={title}
        trayPlaceHolders={trayPlaceHolders}
        isLoading={subTray.isLoading}
        renderFooter={renderSubTrayFooter}
        renderHeader={renderSubTrayHeader}
        renderHeaderBeforeDescription={renderSubTrayHeaderBeforeDescription}
        cardContainerStyle={subTrayCardsContainerStyle}
        subTray={subTray}
        accessibilityID={subTrayItem.subTrayID}
        animationManager={this.animationManager}
        animations={subTrayAnimations}
        trayHeight={trayHeight}
        toggleModal={this.toggleModal}
        {...subTrayGroupStyles}
      />
    );
  };

  renderTrayItems = data => {
    const { notificationsCount, images } = this.props;
    const formatedData = [];
    const { optionalItems = [], account, products } = data;
    if (optionalItems.length > 1) {
      formatedData.push(products);
      formatedData.push(optionalItems[0]);
      formatedData.push(optionalItems[1]);
      formatedData.push(account);
    } else {
      formatedData.push(products);
      formatedData.push(account);
    }

    return _map(formatedData, (trayItem, index) => {
      if (trayItem) {
        const _notificationsCount = _sum(_values(notificationsCount[trayItem.title]) || []);
        return {
          title: trayItem.title,
          subTrayTitle: trayItem.subTray.subTrayTitle,
          subTrayID: trayItem.subTrayID,
          icon: images[this.getIconName(trayItem)],
          onPress: () => {
            this.handleOnPressTrayItem(index, trayItem);
          },
          content: this.renderContent(trayItem.subTray, trayItem.title, trayItem),
          notification: _notificationsCount,
          isExpandedTrayEnabled: trayItem.subTray.isExpandedTrayEnabled,
          expandedTrayItems: trayItem.subTray.expandedTrayItems,
          withBusinessOverview: trayItem.subTray.withBusinessOverview,
        };
      }
    });
  };

  render() {
    const { activeSubTray } = this.state;

    const {
      trayIcon,
      trayTabStyles,
      customTrayIconStyle,
      data,
      isModalVisible,
      images,
      extraStyles,
      onRefresh,
      refreshInterval,
      trayPlaceHolders,
      dropTray,
      upTray,
      showModal,
      hideModal,
      setDropTray,
      trayType,
      welcomeMessage,
      welcomeMessageBreakTime,
      notificationsBreakTime,
      notifications,
      trayHeight,
      expandedTrayHeight,
      normalTrayHeight,
    } = this.props;

    const trayItems = this.renderTrayItems(data);

    const isExpandedTrayEnabled =
      activeSubTray !== -1 ? _get(trayItems[activeSubTray], 'isExpandedTrayEnabled', false) : false;
    const expandedTrayItems =
      activeSubTray !== -1 ? _get(trayItems[activeSubTray], 'expandedTrayItems', []) : undefined;
    const shouldTrayExpand = this.shouldBeExpandedTray(expandedTrayItems, isExpandedTrayEnabled);
    const shouldTrayCollapse = !isExpandedTrayEnabled && activeSubTray !== -1;
    return (
      <Tray
        expandedTrayHeight={expandedTrayHeight}
        normalTrayHeight={normalTrayHeight}
        setTrayHeight={this.props.setTrayHeight}
        shouldTrayExpand={shouldTrayExpand}
        shouldTrayCollapse={shouldTrayCollapse}
        trayItems={trayItems}
        toggleModal={this.toggleModal}
        isModalVisible={isModalVisible}
        activeSubTray={activeSubTray}
        extraStyles={extraStyles}
        images={images}
        onRefresh={onRefresh}
        refreshInterval={refreshInterval}
        onPressTobi={this.handleOnPressTobi}
        trayPlaceHolders={trayPlaceHolders}
        trayIcon={trayIcon}
        tabStyles={trayTabStyles}
        customTrayIconStyle={customTrayIconStyle}
        dropTray={dropTray}
        upTray={upTray}
        showModal={showModal}
        hideModal={hideModal}
        setDropTray={setDropTray}
        trayType={trayType}
        welcomeMessage={welcomeMessage}
        welcomeMessageBreakTime={welcomeMessageBreakTime}
        notificationsBreakTime={notificationsBreakTime}
        notifications={notifications}
        animationManager={this.animationManager}
        lottieViewHeight={trayHeight}
      // {...this._setNormalTrayHeightBasedOnActiveSubTray(trayItems[activeSubTray])}
      />
    );
  }
}

TrayHoc.defaultProps = {
  data: {},
  isModalVisible: false,
  toggleModal: () => { },
  notificationsCount: 0,
  onPressTrayItem: () => { },
  images: {},
  onPressSubTrayItems: () => { },
  theme: LightThemeColors,
  expandedTrayHeight: 0.85 * Dimensions.get('screen').height,
  normalTrayHeight: defaultNormalTrayHeight,
  isSubTrayItemsLocked: false,
};

TrayHoc.propTypes = {
  data: PropTypes.object.isRequired,
  isModalVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  notificationsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  onPressTrayItem: PropTypes.func.isRequired,
  images: PropTypes.object,
  onPressSubTrayItems: PropTypes.func.isRequired,
  extraStyles: ViewPropTypes.style,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  componentList: PropTypes.object,
  isLoadingError: PropTypes.bool,
  errorConfig: PropTypes.object,
  trayPlaceHolders: PropTypes.object,
  subTrayCardsLoadingConfig: PropTypes.object,
  shimmerPlaceholderConfig: PropTypes.object,
  theme: PropTypes.object,
  trayIcon: PropTypes.element,
  trayTabStyles: PropTypes.shape({
    title: TextPropTypes.style,
    icon: ViewPropTypes.style,
  }),
  customTrayIconStyle: ViewPropTypes.style,
  onRefresh: PropTypes.func,
  onPressTobi: PropTypes.func,
  refreshInterval: PropTypes.number,
  dropTray: PropTypes.bool,
  upTray: PropTypes.bool,
  setDropTray: PropTypes.func,
  renderSubTrayFooter: PropTypes.func,
  subTrayCardsContainerStyle: ViewPropTypes.style,
  subTrayImageProps: PropTypes.object,
  subTraySubTitleProps: PropTypes.object,
  trayType: PropTypes.oneOf(Object.values(TRAY_TYPES)),
  welcomeMessage: PropTypes.string,
  welcomeMessageBreakTime: PropTypes.number,
  notificationsBreakTime: PropTypes.number,
  notifications: PropTypes.arrayOf(Object),
  trayHeight: PropTypes.number,
  expandedTrayHeight: PropTypes.number,
  normalTrayHeight: PropTypes.number,
  setTrayHeight: PropTypes.func,
  renderSubTrayHeader: PropTypes.func,
  renderSubTrayHeaderBeforeDescription: PropTypes.func,
  setNormalTrayHeightBasedOnActiveSubTray: PropTypes.func,
  isSubTrayItemsLocked: PropTypes.bool,
  subTrayGroupStyles: PropTypes.object,
  cardDescriptionSpace: PropTypes.number,
};

export default withTheme(TrayHoc);
